<div class="d-flex align-items-start justify-content-center px-4 px-md-6 py-md-6">
  <div class="flex-1 d-flex justify-content-center">
    <img src="/assets/images/3d-lock.webp" alt="3d-lock" width="200" height="200" class="image" />
  </div>

  <ds-button
    (click)="hideModal.emit()"
    variant="icon"
    size="s"
    icon="xmark"
    label="Close"
    class="d-none d-md-inline ml-auto"
    data-id="hide"
  />
</div>

@let discount = (ancillaryBundle?.discount || 0) * 100;

<div class="d-flex flex-column px-4 px-md-6 mt-4 mt-md-0">
  <h1 class="semi-bold">Your trip is completely unprotected</h1>

  <p class="mt-3">
    If your plans change or your flight is disrupted, you’ll need<br />to handle everything
    yourself.
  </p>

  <div class="d-flex flex-column g-6 mt-6">
    @for (section of sections; track section) {
      <div class="d-flex flex-1 flex-column g-3">
        <p class="semi-bold">{{ section.title }}</p>

        @for (item of section.items; track item) {
          <div class="d-flex g-2">
            <img
              src="/assets/icons/{{ item.icon }}.svg"
              alt="{{ item.icon }}"
              width="20"
              height="20"
            />

            <p>{{ item.label }}</p>
          </div>
        }
      </div>
    }
  </div>

  <p class="semi-bold mt-6 text-green-750">
    Add it now and save {{ discount }}% with the bundle price
  </p>
</div>

<div class="d-flex flex-column px-4 px-md-6 my-4 my-md-6 g-2">
  @let pricePerTraveler = ancillaryBundle?.pricePerTraveler || 0;
  @let priceWithoutDiscountPerTraveler = ancillaryBundle?.priceWithoutDiscountPerTraveler || 0;

  <hr />

  <p class="caption">
    Full Peace bundle: Cancel For Any Reason + Premium Disruption Protection.<br />Save
    {{ discount }}% on full protection.
  </p>

  <ds-button
    (click)="ancillariesBundleContinue.emit()"
    [label]="
      'Add full protection for ' +
      (pricePerTraveler | portalCurrency) +
      ' ' +
      (priceWithoutDiscountPerTraveler | portalCurrency) +
      ' pp'
    "
    data-id="add"
  />

  <ds-button
    (click)="ancillariesBundleNext.emit()"
    variant="secondary"
    label="No, I’ll take the risk"
    data-id="no"
  />
</div>
